/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';

import { InventoryAlertModel } from '../model/inventoryAlertModel';
import { SmartDineResponseInventoryAlertModel } from '../model/smartDineResponseInventoryAlertModel';
import { SmartDineResponseListInventoryAlertModel } from '../model/smartDineResponseListInventoryAlertModel';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class InventoryAlertControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param inventoryMasterId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createInventoryAlert(body: InventoryAlertModel, restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseInventoryAlertModel>;
    public createInventoryAlert(body: InventoryAlertModel, restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseInventoryAlertModel>>;
    public createInventoryAlert(body: InventoryAlertModel, restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseInventoryAlertModel>>;
    public createInventoryAlert(body: InventoryAlertModel, restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createInventoryAlert.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling createInventoryAlert.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling createInventoryAlert.');
        }

        if (inventoryMasterId === null || inventoryMasterId === undefined) {
            throw new Error('Required parameter inventoryMasterId was null or undefined when calling createInventoryAlert.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }
        if (inventoryMasterId !== undefined && inventoryMasterId !== null) {
            queryParameters = queryParameters.set('inventoryMasterId', <any>inventoryMasterId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseInventoryAlertModel>('post',`${this.basePath}/api/admin/inventoryalerts`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param inventoryMasterId 
     * @param inventoryAlertId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteInventoryAlert(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseInventoryAlertModel>;
    public deleteInventoryAlert(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseInventoryAlertModel>>;
    public deleteInventoryAlert(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseInventoryAlertModel>>;
    public deleteInventoryAlert(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling deleteInventoryAlert.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling deleteInventoryAlert.');
        }

        if (inventoryMasterId === null || inventoryMasterId === undefined) {
            throw new Error('Required parameter inventoryMasterId was null or undefined when calling deleteInventoryAlert.');
        }

        if (inventoryAlertId === null || inventoryAlertId === undefined) {
            throw new Error('Required parameter inventoryAlertId was null or undefined when calling deleteInventoryAlert.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }
        if (inventoryMasterId !== undefined && inventoryMasterId !== null) {
            queryParameters = queryParameters.set('inventoryMasterId', <any>inventoryMasterId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseInventoryAlertModel>('delete',`${this.basePath}/api/admin/inventoryalerts/${encodeURIComponent(String(inventoryAlertId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param inventoryMasterId 
     * @param inventoryAlertId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInventoryAlert(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseInventoryAlertModel>;
    public getInventoryAlert(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseInventoryAlertModel>>;
    public getInventoryAlert(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseInventoryAlertModel>>;
    public getInventoryAlert(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getInventoryAlert.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling getInventoryAlert.');
        }

        if (inventoryMasterId === null || inventoryMasterId === undefined) {
            throw new Error('Required parameter inventoryMasterId was null or undefined when calling getInventoryAlert.');
        }

        if (inventoryAlertId === null || inventoryAlertId === undefined) {
            throw new Error('Required parameter inventoryAlertId was null or undefined when calling getInventoryAlert.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }
        if (inventoryMasterId !== undefined && inventoryMasterId !== null) {
            queryParameters = queryParameters.set('inventoryMasterId', <any>inventoryMasterId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseInventoryAlertModel>('get',`${this.basePath}/api/admin/inventoryalerts/${encodeURIComponent(String(inventoryAlertId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param inventoryMasterId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInventoryAlerts(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseListInventoryAlertModel>;
    public getInventoryAlerts(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseListInventoryAlertModel>>;
    public getInventoryAlerts(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseListInventoryAlertModel>>;
    public getInventoryAlerts(restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getInventoryAlerts.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling getInventoryAlerts.');
        }

        if (inventoryMasterId === null || inventoryMasterId === undefined) {
            throw new Error('Required parameter inventoryMasterId was null or undefined when calling getInventoryAlerts.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }
        if (inventoryMasterId !== undefined && inventoryMasterId !== null) {
            queryParameters = queryParameters.set('inventoryMasterId', <any>inventoryMasterId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseListInventoryAlertModel>('get',`${this.basePath}/api/admin/inventoryalerts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param inventoryMasterId 
     * @param inventoryAlertId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateInventoryAlert(body: InventoryAlertModel, restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseInventoryAlertModel>;
    public updateInventoryAlert(body: InventoryAlertModel, restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseInventoryAlertModel>>;
    public updateInventoryAlert(body: InventoryAlertModel, restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseInventoryAlertModel>>;
    public updateInventoryAlert(body: InventoryAlertModel, restaurantId: string, restaurantBranchId: string, inventoryMasterId: string, inventoryAlertId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateInventoryAlert.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling updateInventoryAlert.');
        }

        if (restaurantBranchId === null || restaurantBranchId === undefined) {
            throw new Error('Required parameter restaurantBranchId was null or undefined when calling updateInventoryAlert.');
        }

        if (inventoryMasterId === null || inventoryMasterId === undefined) {
            throw new Error('Required parameter inventoryMasterId was null or undefined when calling updateInventoryAlert.');
        }

        if (inventoryAlertId === null || inventoryAlertId === undefined) {
            throw new Error('Required parameter inventoryAlertId was null or undefined when calling updateInventoryAlert.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }
        if (inventoryMasterId !== undefined && inventoryMasterId !== null) {
            queryParameters = queryParameters.set('inventoryMasterId', <any>inventoryMasterId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseInventoryAlertModel>('put',`${this.basePath}/api/admin/inventoryalerts/${encodeURIComponent(String(inventoryAlertId))}`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
